import { VisualizationManager } from '@sas-dvr/ltjs-commons';
import { merge } from 'rxjs';
import { loadVisualElementController } from './loadVisualElement';
import { DataVisualElementController } from '@sas-dvr/ltjs-bird';
import { createSortMenuHandler } from '../util/sortUtils';
import { VisualElementControllerLoader } from './LoaderFactory';
import { getExplainObservables } from '../util/explainUtils';

export const loadDataVisualElementController: VisualElementControllerLoader<VisualizationManager> = (
  visualController,
  visualElementController,
  unload$,
  myActions$,
  state$,
  deps,
  lifecyleActions,
  visualizationManager
) => {
  if (!(visualElementController instanceof DataVisualElementController)) {
    throw new Error('Expected the controller to be a DataVisualElementController');
  }
  const id = deps.getKey(visualElementController);

  const handleSortMenu$ = createSortMenuHandler(
    visualElementController,
    visualizationManager ?? null,
    id,
    myActions$,
    state$
  );

  const handleExplain$ = getExplainObservables(
    id,
    visualController,
    visualElementController,
    state$,
    unload$
  );

  const loadVisualElement$ = loadVisualElementController(
    visualController,
    visualElementController,
    unload$,
    myActions$,
    state$,
    deps,
    lifecyleActions
  );

  return merge(loadVisualElement$, handleSortMenu$, handleExplain$);
};
